import Component from 'react-pure-render/component';
import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';

export default class DisplayDataItem extends Component {
  static propTypes = {
    title: PropTypes.string,
    sm: PropTypes.number,
    value: PropTypes.any,
    value2: PropTypes.any,
    separator: PropTypes.string,
    show: PropTypes.bool,
    message: PropTypes.string,
    isLink: PropTypes.bool,
    linkUrl: PropTypes.string,
    icon: PropTypes.string
  };

  static defaultProps = {
    separator: ' - ',
    show: true,
    message: 'Sem registro'
  };

  render() {
    const {
      title,
      sm,
      value,
      value2,
      separator,
      show,
      message,
      isLink,
      linkUrl,
      icon
    } = this.props;

    if (!show) {
      return null;
    }

    return (
      <Col sm={sm}>
        {title && <b className="dd-title">{title}</b>}
        <div className="dd-content" id={title}>
          {!value && typeof value === 'undefined' && <i>{message}</i>}

          {value && !isLink && <span> {value} </span>}

          {value && isLink && (
            <a href={linkUrl} target="_blank">
              <span className={'module-color'}>{value}</span>
              {icon && (
                <i
                  style={{ marginLeft: '8px', transform: 'scaleX(-1)' }}
                  className={`${icon} module-color`}
                ></i>
              )}
            </a>
          )}

          {value2 && !isLink && (
            <span>
              {separator} {value2}
            </span>
          )}
        </div>
      </Col>
    );
  }
}
